import { Box, FormControl, FormControlLabel, Radio, RadioGroup, } from "@material-ui/core";

import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import WorkFlow from "./WorkFlow";
import Views from "./Views";
import PortTransit from "./PortTransit";
import { handleOpenWorkflowDialog, getOpenWorkflowDialog } from '../../reducers/uiSlice';

import { getExceptionDetails } from '../../actions/editOrderActions';
import { getUserPreference } from "../../utilities/common";
import OverSize from "./OverSize";
import { useToken } from "../../utilities/hooks";


const WORKFLOW_ENABLE_OPERATION_WAREHOUSE_LIST_CA = [1, 2, 4];
const WORKFLOW_ENABLE_OPERATION_WAREHOUSE_LIST_US = [1, 2, 3, 4, 17];
const useStyles = makeStyles((theme) => ({
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    verticalMargin: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    textSpace: {
        marginRight: theme.spacing(1)
    }
}))

// Only Vancouver and Toronto using Workflow Management


function WorkflowManagement(props) {

    const classes = useStyles();
    const { t } = useTranslation('workflowManagement');
    const dispatch = useDispatch();
    const tokenContents = useToken();
    const userUS = tokenContents.userUS;

    const openModal = useSelector(getOpenWorkflowDialog);

    const [value, setValue] = useState('0');


    const userPref = getUserPreference();
    const [enableWorkflow, setEnableWorkflow] = useState(false);
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    useEffect(() => {
        if (openModal) {
            setValue('0');
            dispatch(getExceptionDetails());
        }
    }, [openModal])

    useEffect(() => {
        if (props.open) {
            const list = userUS ? WORKFLOW_ENABLE_OPERATION_WAREHOUSE_LIST_US : WORKFLOW_ENABLE_OPERATION_WAREHOUSE_LIST_CA;
            if (list.includes(userPref.userCity)) {
                setValue('0');
                setEnableWorkflow(true);
            } else {
                setValue('1');
                setEnableWorkflow(false);
            }
        }
    }, [props.open])
    return (

        <Box>

            <FormControl>
                <RadioGroup
                    value={value}
                    onChange={handleChange}
                    row
                >
                    <div>
                        <FormControlLabel value='0' control={<Radio />} label={t('workflow')} />
                        <FormControlLabel value='2' control={<Radio />} label={t('port transit')} />
                    </div>
                    <FormControlLabel value='3' control={<Radio />} label={t('heavy  parcel')} />
                    <FormControlLabel value='1' control={<Radio />} label={t('view')} />


                </RadioGroup>
            </FormControl>


            <div style={{ marginTop: 20 }}>
                <div hidden={value !== '0'}>
                    <WorkFlow />
                </div>
                <div hidden={value !== '1'}>
                    <Views />
                </div>
                <div hidden={value !== '2'}>
                    <PortTransit />
                </div>
                <div hidden={value !== '3'}>
                    <OverSize />
                </div>


            </div>

        </Box>
    )


}

export default WorkflowManagement;